module.exports = __webpack_public_path__ + "img/CLOCK.bc1beae9.svg";